import __request__ from "routing/request";
export function get(streamid, requestOptions) {
  return __request__("GET", `/streams/${streamid}/rules`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(streamid, JSONbody, requestOptions) {
  return __request__("POST", `/streams/${streamid}/rules`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function types(streamid, requestOptions) {
  return __request__("GET", `/streams/${streamid}/rules/types`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(streamid, streamRuleId, JSONbody, requestOptions) {
  return __request__("PUT", `/streams/${streamid}/rules/${streamRuleId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBystreamidAndstreamRuleId(streamid, streamRuleId, requestOptions) {
  return __request__("GET", `/streams/${streamid}/rules/${streamRuleId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(streamid, streamRuleId, requestOptions) {
  return __request__("DELETE", `/streams/${streamid}/rules/${streamRuleId}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
